import React, { useEffect, useState } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import UserNavbar from '../Navbar/UserNavbar'
import { AiOutlineFileText } from 'react-icons/ai'
import axios from 'axios'
import { toast } from 'react-toastify';
import { Button, DatePicker, Input, Select, Table ,Checkbox} from 'antd';
import dayjs from 'dayjs';
import { Option } from 'antd/es/mentions';
import { useNavigate } from 'react-router-dom'
import { ExpenseEntrySummary, PaymentRecieveSummery } from '../Api/All_Api'
import TitleNavbar from '../Navbar/TitleNavbar'


const PaymentRecieveSummary = () => {
     const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];
    
      const role = sessionStorage.getItem('role');

      
        const sessionYear = sessionStorage.getItem('sessionYear');
        const year = sessionYear
      const navigate = useNavigate();
          useEffect(() => {
            if (!sessionYear) {
              sessionStorage.clear();
              navigate('/')
            }
          },[])
    
      const [errors, setErrors] = useState({
        toDate: "",
        mineName: "",
        fromDate: "",
      });
      const [toDate, setToDate] = useState("");
      const [PaymentRecieve, setPaymentRecieve] = useState([]);
      const [fromDate, setFromDate] = useState("");
        const [pageSize, setPageSize] = useState(10);
          const [filteredData, setFilteredData] = useState([]);
          const [currentPage, setCurrentPage] = useState(1);
          const [totalEntries, setTotalEntries] = useState(0);
          const[viewButton,setViewButton]=useState(false);

   //======Search data from table===============
   const handleSearch = (value) => {
    const filtered = PaymentRecieve.filter((item) =>
      Object.values(item).some((val) =>
        val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length); // Update total entries count after filtering
    setCurrentPage(1);
  };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Sale Bill Number",
      dataIndex: "sale_bill_no",
      key: "sale_bill_no",
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
        title: " Recieved Amount",
        dataIndex: "receieved_amount",
        key: "receieved_amount",
      },
      {
        title: "Payment Recieved Date",
        dataIndex: "payment_receieved_date",
        key: "payment_receieved_date",
      },
    
 
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
    

     const handleSubmit = async () => {
        // Validate the dates
        if (!fromDate || !toDate) {
          setErrors({
            ...errors,
            fromDate: fromDate ? "" : "From Date is required.",
            toDate: toDate ? "" : "To Date is required.",
          });
          return;
        }
         
        // Call the fetchExpenses function after validation
        await fetchPaymentRecieve();
        setErrors({
          ...errors,
          fromDate:  "",
          toDate:  "" ,
        });
        setViewButton(true);
      };
    // ==============Get table data================
  
    let isError = false;
  
    const fetchPaymentRecieve = async () => {
    const formattedDate = fromDate
            ? dayjs(fromDate).format("YYYY-MM-DD")
            : "";
              const formattedDate1 = toDate
                ? dayjs(toDate).format("YYYY-MM-DD")
                : "";
    
      try {
        const response = await axios.get(`${PaymentRecieveSummery}?fromDate=${formattedDate}&toDate=${formattedDate1}`);
        if (response.data !== null) {
          setPaymentRecieve(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
         
        }
      } catch (error) {
        if (!isError) {
          // Check if the error has already been triggered
          console.error("Error fetching Payment Recieved:", error);
          toast.error("Failed to fetch Payment Recieved data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };

           //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================

      
  return (
    <> 
     <AdminNavbar /> 
       <div className="p-0 m-0">
    


              <div
              className="row m-0"
              style={navbg}
            >
              <div
                className="col-12 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                <span className="px-md-5"  style={{ flexGrow: 1 }}>
                  {" "}
                  <AiOutlineFileText /> &nbsp; Payment Receive Summary
                </span>
                <span  >
            <TitleNavbar/>
            </span>
              </div> 
              </div>


              <div className='row m-0 p-0 pt-3'>
          <div className='col-12 col-md-2 col-lg-4'></div>
          <div className='col-12 col-md-8 col-lg-4'>
              <div className="row px-md-5 mt-3  m-0">
                <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>From Date </label>
                    </div>
                    <div className="col-9 ">
                    <DatePicker
                        defaultValue={null}
                        value={fromDate}
                        onChange={(value) => setFromDate(value)}
                        className="w-100"
                        format={dateFormatList}
                      />
                        {errors.fromDate && (
                          <div className="errorField">{errors.fromDate}</div>
                        )}
                    </div>
                  </div>
                </div>

                <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>To Date </label>
                    </div>
                    <div className="col-9 ">
                    <DatePicker
                        defaultValue={null}
                        value={toDate}
                        onChange={(value) => setToDate(value)}
                        className="w-100"
                        format={dateFormatList}
                      />
                        {errors.toDate && (
                          <div className="errorField">{errors.toDate}</div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleSubmit}
                  >
                    View
                  </Button>
                  
                 
                </div>

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: "2px solid #bfb597" }}
                ></div>
              </div>
          </div>
          <div className='col-12 col-md-2 col-lg-4'></div>
        </div>
       
        </div>

   {/*================ Table =========================*/}
      {viewButton&&(   <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
          <div className='col-12 col-md-2'></div>
            <div  className="col-12 col-md-8 py-3 shadow border"
              style={{ marginBottom: "50px", backgroundColor: "white" }}
            >
              <div
                className="col-12 px-md-5"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                  <Select
                    defaultValue={pageSize}
                    onChange={handlePageSizeChange}
                    style={{ width: 120, textAlign: "center" }}
                  >
                    <Option value={10}>10</Option>
                    <Option value={20}>20</Option>
                    <Option value={30}>30</Option>
                  </Select>
                </div>
  
                <div className="pt-4 pt-md-0">
                  <Input.Search
                    placeholder="Search"
                    onSearch={handleSearch}
                    style={{ width: 200, marginBottom: 16 }}
                  />
                </div>
              </div>
  
              <div style={{ backgroundColor: "white" }}>
                <Table
                  bordered
                  style={{ padding: "0px 20px", overflowX: "auto" }}
                  columns={columns}
                  dataSource={filteredData}
                  pagination={{
                    pageSize: pageSize,
                    total: totalEntries,
                    showTotal: (total, range) =>
                      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                    current: currentPage,
                    onChange: (page) => setCurrentPage(page),
                  }}
                  showSorterTooltip={false}
                  rowKey={(record) => record.id}
                   components={components}
                />
              </div>
            </div>
            <div className='col-12 col-md-2'></div>
          </div>)} 
        
  


                </>
  )
}

export default PaymentRecieveSummary